import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { supabase } from "@/integrations/supabase/client"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const getSupabaseStorageUrl = (bucketName: string, filePath: string): string => {
  const SUPABASE_URL = "https://zbvjxryqzrygkixfuidj.supabase.co";
  return `${SUPABASE_URL}/storage/v1/object/public/${bucketName}/${filePath}`;
};
